export const MESSAGE = {
  SUCCESS_FULL: "Thank you for choosing us! We have received your job request. We'll contact you to confirm your project details."
}
